import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=A%20stylized%20cinematic%20abstract%20background%20with%20flowing%20curved%20ribbons%20in%20warm%20deep%20red%20and%20dark%20charcoal%20tones%2C%20soft%20gradient%20overlay%2C%20modern%20minimalist%20design%2C%20theatrical%20atmosphere%2C%20clean%20smooth%20curves%2C%20cinematic%20widescreen%20composition&width=1800&height=900&seq=hero-bg-main&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/65"></div>

      <div className="absolute inset-0 flex flex-col items-center justify-center px-4 z-10 w-full">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-white text-center mb-4 leading-tight">
          发现精彩视频世界
        </h1>
        <p className="text-sm md:text-lg text-white/80 text-center max-w-xl mb-8 leading-relaxed">
          海量高清影视、综艺、动漫、纪录片免费在线观看，畅享极致播放体验
        </p>

        <div className="w-full max-w-xl flex flex-col sm:flex-row gap-3">
          <div className="relative flex-1">
            <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-foreground-400 text-lg"></i>
            <input
              type="text"
              placeholder="搜索你喜欢的电影、剧集、综艺..."
              className="w-full pl-11 pr-4 py-3.5 rounded-full text-sm bg-white/95 backdrop-blur border-0 outline-none focus:ring-2 focus:ring-primary-400 text-foreground-900 placeholder-foreground-400"
            />
          </div>
          <Link
            to="/category/movie"
            className="px-8 py-3.5 rounded-full bg-primary-500 text-white font-medium text-sm whitespace-nowrap hover:bg-primary-600 transition-colors duration-200 text-center"
          >
            开始探索
          </Link>
        </div>

        <div className="flex items-center gap-6 mt-8">
          {[
            { value: '12,580+', label: '视频资源' },
            { value: '350万+', label: '日活用户' },
            { value: '8.9亿+', label: '总播放量' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-lg md:text-2xl font-bold text-white">{stat.value}</div>
              <div className="text-xs md:text-sm text-white/60 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}